import React from 'react';
import { Modal, Stack, Text, Group, Divider, Box, useMantineColorScheme, Image } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import enarmLogo from '../assets/enarm_logo.png';

interface AboutModalProps {
  opened: boolean;
  onClose: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ opened, onClose }) => {
  const currentYear = new Date().getFullYear();
  const version = '2.0.1';
  const { colorScheme } = useMantineColorScheme();
  
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      size={290}
      overlayProps={{ 
        opacity: 0.4,
        blur: 8,
      }}
      styles={{
        content: {
          backgroundColor: colorScheme === 'dark' ? 'rgba(30, 41, 59, 0.98)' : 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(10px)',
          border: `1px solid ${colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
          borderRadius: '12px',
          boxShadow: colorScheme === 'dark' 
            ? '0 20px 40px rgba(0, 0, 0, 0.5)'
            : '0 20px 40px rgba(0, 0, 0, 0.2)',
        },
        header: {
          backgroundColor: 'transparent',
          borderBottom: 'none',
          paddingBottom: 0
        },
        body: {
          padding: '1.75rem 1rem'
        }
      }}
    >
      <Stack gap="lg">
        {/* Header */}
        <Box ta="center">
          <Group justify="flex-start" mb="xs">
            <IconInfoCircle size={18} color="#64748b" />
          </Group>
          <Group justify="center" mb="sm">
            <Image
              src={enarmLogo}
              alt="ENARM360 Logo"
              width={60}
              height={60}
              fit="contain"
            />
          </Group>
          <Text size="xs" c="dimmed">
            Plataforma de preparación médica
          </Text>
        </Box>

        <Divider />

        {/* Información del sistema */}
        <Stack gap="xs">
          <Group justify="space-between">
            <Text size="xs" fw={500}>Versión</Text>
            <Text size="xs" c="dimmed">
              {version}
            </Text>
          </Group>

          <Group justify="space-between">
            <Text size="xs" fw={500}>Fecha de lanzamiento</Text>
            <Text size="xs" c="dimmed">
              Octubre 2025
            </Text>
          </Group>

          <Group justify="space-between">
            <Text size="xs" fw={500}>Última actualización</Text>
            <Text size="xs" c="dimmed">
              Junio 2026
            </Text>
          </Group>
        </Stack>

        <Divider />

        {/* Footer */}
        <Box ta="center">
          <Text size="xs" c="dimmed">
            © {currentYear} ENARM360. Todos los derechos reservados.
          </Text>
        </Box>
      </Stack>
    </Modal>
  );
};

export default AboutModal;